module.exports = __webpack_public_path__ + "img/close.bcb27d04.svg";